import React,{useState} from 'react';
import styled from 'styled-components'
import PropTypes from "prop-types";
import Avatar from './Avatar';
import BoldText from './BoldText'
import { QUERY } from '../Queries/isLoggedIn'
import { useQuery } from '@apollo/react-hooks'
import { media } from '../styles/Mixin'
import NormalText from './NormalText';
import { SaveInCategoryWindow } from './SaveInCategoryWindow';
import CreateCategory_NeedCheck from '../Components/CreateCategory_NeedCheck'
import ReCommentBox from './ReCommentBox';

export const CommentBox = ({
    topProfileImage,
    topAuthorName,
    topCommentText,
    comment,
    replyCount,
    reComments
})=>{
    /**
     * avatar size m_md
     */
    const { data: { auth: { isLoggedIn } } } = useQuery(QUERY)
    const [btnState, setBtnState] = useState(false)
    const [deleteState, setDeleteState] = useState(false)
    const [saveCtgWindow, setSaveCtgWindow] = useState(false)
    const [createCategoryWindow, setCreateCategoryWindow] = useState(false)

    const saveBtn = async() =>{
        setBtnState(true)
        setDeleteState(true)
        if(isLoggedIn){
          setSaveCtgWindow(true)  
        }else{
          setSaveCtgWindow(false)  
          alert("로그인 후에 이용이 가능합니다 😁")
        }
        // setBtnState(false)
    }
    
    return (
      <CommentInfoBox>
        <LeftInfo>
          <AvatarBox>
            <Avatar url={topProfileImage} size={"m_md"} />
            {/* <Avatar url={"https://yt3.ggpht.com/a-/AOh14GiX4zNJW-Rxu5OiUYFVXTSKcvFcBLqYmf6eU6l4=s100-c-k-c0xffffffff-no-rj-mo"} size={"m_md"} /> */}
          </AvatarBox>
        </LeftInfo>
        <RightInfo>
          <Row>
            <AuthorDisplayNameBox>
              <BoldText text={topAuthorName} />
              {/* <BoldText text={"parkminh5"} /> */}
            </AuthorDisplayNameBox>
            <ButtonBox>
              {btnState || deleteState ? (
                <LoadingText text={"Loading..."} />
              ) : (
                <SaveBtnText text={"저장 🔖"} onClick={saveBtn} />
              )}
              {/* : <UpdateBtnText text={"수정 🛠"}/> */}
            </ButtonBox>
          </Row>
          <TextBox>
            <CustomNormalText text={topCommentText} />
            {/* <CustomNormalText text={"안녕하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는"}/> */}
          </TextBox>
          {replyCount > 0 &&
            reComments.map((replies,i) => (
              // 넘겨주는 쪽에서 commentSearchPresenter에서는 
              <ReCommentInfoBox key={i}>
                <ReCommentBox 
                  reProfileImage={replies.snippet ? replies.snippet.authorProfileImageUrl : replies.makerChannelProfileImageUrl}
                  reAuthorName={replies.snippet ? replies.snippet.authorDisplayName : replies.makerChannelDisplayName} 
                  reCommentText={replies.snippet ? replies.snippet.textOriginal : replies.textOriginal}
                />
              </ReCommentInfoBox>
            ))}
        </RightInfo>
        {saveCtgWindow && (
          <SaveInCategoryWindow
            setSaveCtgWindow={setSaveCtgWindow}
            comment={comment}
            setCreateCategoryWindow={setCreateCategoryWindow}
            setBtnState={setBtnState}
            setDeleteState={setDeleteState}
          />
        )}
        {createCategoryWindow && (
          <CreateCategory_NeedCheck
            setCreateCategoryWindow={setCreateCategoryWindow}
            comment={comment}
            setBtnState={setBtnState}
            setDeleteState={setDeleteState}
            />
        )}
      </CommentInfoBox>
    );
}


export default CommentBox

CommentBox.propTypes = {
  topProfileImage: PropTypes.string.isRequired,
  topAuthorName: PropTypes.string.isRequired,
  topCommentText: PropTypes.string.isRequired,
  replyCount: PropTypes.number.isRequired
};

const Row = styled.div`
    width:100%;
    display:flex;
    flex-direction:row;
`


const CommentInfoBox = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    width:100%;
    margin-bottom:10px;
`

const LeftInfo = styled.div`
    /* width:100%; */
    display:flex;
    flex-direction:row;
    justify-content:center;
`

const RightInfo = styled.div`
    /* width:100%; */
    display:flex;
    flex-direction:column;
    align-items:flex-start;
`

const AvatarBox = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    ${media.deskTop`
    margin-right:10px;
    `}
    ${media.mobile`
    margin-right:5px;
    `}
    
`

const AuthorDisplayNameBox = styled.div`
    display:flex;
    flex-direction:row;
    margin-right:10px;
`


const ButtonBox = styled.div`
    display:flex;
    flex-direction:row;
`

const SaveBtnText = styled(BoldText)`
    cursor:pointer;
    color:${props=> props.theme.blueColor};
`

const TextBox = styled.div`
`

const CustomNormalText = styled(NormalText)`

`

const ReCommentInfoBox = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    width:100%;
`

const LoadingText = styled(BoldText)`
    color:${props => props.theme.blueColor};
`

